export const sidebarMenu = [
    {
        name: "accueil",
        linkTo: "/",
        icon: "/img/menu/home.svg",
        subMenu: []
    },
    {
        name: "finances",
        linkTo: "/finances",
        icon: "/img/menu/money.svg",
        subMenu: [
            {
                name: "payouts",
                linkTo: "/finances/payouts",
            },
            {
                name: "deposits",
                linkTo: "/finances/deposits",
            },
            {
                name: "transactions",
                linkTo: "/finances/transactions",
            }
        ]
    },
    {
        name: "users",
        linkTo: "/users",
        icon: "/img/menu/usersIcon.svg",
        subMenu: [
            {
                name: "users_list",
                linkTo: "/users",
            }        
        ]
    }
]